import { IncidentCustomer } from './incident-customer.model';
import { IncidentVehicle } from './incident-vehicle.model';
import { Entity } from '../../shared/models/entity.model';
import { LegislativeChangeDateType } from './legislativeChangeDateType.model';
import { IncidentItemKey } from './incident-item-key.model';

export class IncidentModel extends Entity {
    private _occurrenceDate: Date;
    private _receivedDate: Date;

    public searchType: string;
    public incidentCategoryTypeId: number;
    public violationCode: string;
    public acdCodeId = 0;
    public acdCodeDisplayValue: string;
    public incidentTypeDescription: string;
    public incidentTypeDisplayValue: string;
    public prohibitionReviewed: boolean;
    public satisfied: boolean;
    public id = 0;
    public incidentNumberId = 0;
    public convictionRequestId = 0;
    public incidentTypeId: number;
    public incidentGroupTypeId: number;
    public reportingJurisdictionId: number;
    public reportingAZCountyId: number;
    public isEventWOProhibition: boolean;
    public isExpunged: boolean;
    public get occurrenceDate(): Date {
        return this._occurrenceDate;
    }
    public set occurrenceDate(value: Date) {
        this._occurrenceDate = this.ensureDate(value);
    }
    public get receivedDate(): Date {
        return this._receivedDate;
    }
    public set receivedDate(value: Date) {
        this._receivedDate = this.ensureDate(value);
    }
    public effectiveDate: any;
    public endDate: any;
    public referenceNumber: string;
    public statusTypeId: number;
    public statusDisplayValue: string;
    public hasProhibition: boolean;
    public customers: IncidentCustomer[];
    public vehicles: IncidentVehicle[];
    public itemKeys: IncidentItemKey[];
    public legislativeChangeDates: LegislativeChangeDateType[];
    public points: number;
    public isEventWithPoints?: boolean;
    public hasSkippedLetterGeneration: boolean;
    public incidentReferenceTypeId: number;
    public incidentReferenceTypeDisplayValue: string;
    public csrCdlOverride = false;
    public incidentStatusTypeId: number;
    public incidentStatusReasonTypeId: number;
    public incidentStatusTypeDisplayValue: string;
    public incidentStatusReasonTypeDisplayValue: string;
    public updatedDate: any;
    public updatedBy: string;
    public displayPoints: string;

    public forTransport(): any {
        const json: string = JSON.stringify(this);
        const clone: any = JSON.parse(json);

        for (const propertyName in clone) {
            if (propertyName.startsWith('_')) {
                clone[propertyName.substr(1)] = clone[propertyName];
            }
        }

        return clone;
    }
}
